import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import { useAppearanceStore } from './stores/appearance'
import './styles/index.css'
import './styles/fonts.css'
import './styles/theme.css'
import './styles/design-system.css'

if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
  const resizeObserverError = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i
  window.addEventListener('error', (event) => {
    if (resizeObserverError.test(String(event?.message ?? ''))) {
      event.stopImmediatePropagation()
    }
  })
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
useAppearanceStore(pinia).hydrate()
app.use(router)
app.use(vuetify)

app.mount('#app')
